import React from 'react'
import { MerchantContext, SetupMerchant } from './index'
import { MessageStoreContext, SetupMessageStore } from './useMessageStore'
import { ModifierGroupsContext, SetupModifierGroups } from './useModifierGroups'
import {
  StoreOrderTypeCapacityContext,
  SetupStoreOrderTypeCapacity
} from './useStoreOrderTypeCapacity'

export const GlobalContext = ({ children }: { children?: React.ReactNode }) => {
  return (
    <MerchantContext.Provider value={SetupMerchant()}>
      <MessageStoreContext.Provider value={SetupMessageStore()}>
        <ModifierGroupsContext.Provider value={SetupModifierGroups()}>
          <StoreOrderTypeCapacityContext.Provider
            value={SetupStoreOrderTypeCapacity()}
          >
            {children}
          </StoreOrderTypeCapacityContext.Provider>
        </ModifierGroupsContext.Provider>
      </MessageStoreContext.Provider>
    </MerchantContext.Provider>
  )
}

export default GlobalContext
